module.exports = __webpack_public_path__ + "static/faq-2ad94ab36c3f21b461e593f2daaaf6c3.jpg";